import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import DistanceSelector from '../StockItems/DistanceSelector';
import TableGrid from '../StockItems/TableGrid';
import DoGuide from '../Tabs/DoGuide';

function App(props) {

  var getOrig = props.getOrig;
  var anItem = props.anItem;
  var objPath = props.objPath;
  var isInfo = props.isInfo;
  var submitGeneric = props.submitGeneric;
  var currentScreenStyle = props.currentScreenStyle;
  var setMultipleX = props.setMultipleX;
  var formulaPiece = props.formulaPiece;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var stylePath = props.stylePath;
  var organicChanges = props.organicChanges;
  var formulaPieceInGeneral = props.formulaPieceInGeneral;
  var screenSize = props.screenSize;
  var item = props.item;
  var addToExtraScreen = props.addToExtraScreen;


  function getOrigUnit(whatDrop){
    var ss = currentScreenStyle;
    if (isInfo(whatDrop)){
      ss = item.info;
    }
    var orig = false;
    if (ss){
      if (ss[whatDrop]){
        if (ss[whatDrop].t === 'formula'){
          return false;
        }
        orig = ss[whatDrop].t;
      }
    }
    return orig;    
  }

    var capTitle;
    var guidePiece;
    var origDistance1 = getOrig(anItem.i);


    var addChanges = [];
    var origDistance;
    if (origDistance1 && origDistance1.t !== 'formula'){
      origDistance = origDistance1;
    }

    var aI = anItem.i;
    var uintIn = getOrigUnit(anItem.i);
    if (!origDistance){
      if (uintIn === 'bsu'){
      }else{
        origDistance = 0;
      }
    }
    var min = 0;
    var step = 1;
    var max = 50;
    var canRemove = false;
    var uintChoices = [{t:'int', n:'Integer'}];
    var doCombo = false;
    if (aI === 'padding' || aI === 'paddingLeft' || aI === 'paddingRight' || aI === 'paddingTop' || aI === 'paddingBottom' || aI === 'counterPadding'){
      if (aI === 'padding'){
        capTitle = 'Padding';
      }else if (aI === 'paddingLeft'){
        capTitle = 'Padding Left';
      }else if (aI === 'paddingRight'){
        capTitle = 'Padding Right';
      }else if (aI === 'paddingTop'){
        capTitle = 'Padding Top';
      }else if (aI === 'paddingBottom'){
        capTitle = 'Padding Bottom';
      }else if (aI === 'counterPadding'){
        capTitle = 'Counter Padding';
      }
    }else if (aI === 'popUpPadding'){
      max = 1000;
      capTitle = 'Pop Up Padding';
    }else if (aI === 'paddingOpacity'){
      step = 0.01;
      min = 0;
      max = 1;
      uintChoices = [{t:'dc', n:'Decimal'}]
      capTitle = 'Background Opacity'
    }else if (aI === 'numRows'){
      if (!origDistance1){
        origDistance = 8;
      }
      capTitle = 'Number of Rows';
      min = 1;
      max = 30;
    }else if (aI === 'gradDir'){
      capTitle = 'Gradient Direction';
      min = 0;
      max = 360;
    }else if (aI === 'combWidth'){
      capTitle = 'Picture Span';
      min = 0;
      max = 100;
    }else if (aI === 'combStart'){
      capTitle = 'Picture Start';
      min = 0;
      max = 100;
    }else if (aI === 'maskAmt'){
      capTitle = 'Mask Amount';
      min = 0;
      max = 100;
    }else if (aI === 'colWidth' || aI === 'colWidthInternal'){
      uintChoices = [{t:'bsu', n:'Bootstrap Units'}];
      if (aI === 'colWidth'){
        guidePiece = <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'colWidth'}} />
       capTitle = 'Element Width';
      }else{
        capTitle = 'Width of Images';
      }
      min = 1;
      max = 12;
    }else if (aI === 'mt' || aI === 'mb' || aI === 'ml' || aI === 'mr'){
      uintChoices = [{t:'bsu', n:'Bootstrap Units'}];
      if (aI === 'mt'){
        capTitle = 'Margin Top';
      }else if (aI === 'mb'){
        capTitle = 'Margin Bottom';
      }else if (aI === 'ml'){
        capTitle = 'Margin Left';
      }else if (aI === 'mr'){
        capTitle = 'Margin Right';
      }
      min = 0;
      max = 5;
    }else if (anItem.i === 'borderRadius' || anItem.i === 'borderTopLeftRadius' || anItem.i === 'borderTopRightRadius' || anItem.i === 'borderBottomLeftRadius' || anItem.i === 'borderBottomRightRadius' || anItem.i === 'counterRadius'){
      step = 0.01;
      uintChoices = StyleFunctions.decimalWidthPieces();
      capTitle = 'Radius';
      if (anItem.i === 'counterRadius'){
        capTitle = 'Counter Radius';
      }else if (anItem.i === 'borderTopLeftRadius'){
        capTitle = 'Top Left';
      }else if (anItem.i === 'borderTopRightRadius'){
        capTitle = 'Top Right';
      }else if (anItem.i === 'borderBottomLeftRadius'){
        capTitle = 'Bottom Left';
      }else if (anItem.i === 'borderBottomRightRadius'){
        capTitle = 'Bottom Right';
      }
      min = 0;
      max = 50;

      if (anItem.i !== 'counterRadius'){
        var origBorderStyle1 = getOrig('borderStyle');
        var origBorderColor1 = getOrig('borderColor');
        var origBorderWidth1 = getOrig('borderWidth');

        if (origBorderColor1 === false){
          addChanges.push({t:'w',w:objPath.concat(['s', 'borderColor']),n:{t:'raw',v:'rgb(0,0,0)'}});
        }
        if (origBorderStyle1 === false){
          addChanges.push({t:'w',w:objPath.concat(['s', 'borderStyle']),n:{t:'raw',v:'solid'}});
        }
        if (!origBorderWidth1){
          addChanges.push({t:'w',w:objPath.concat(['s', 'borderWidth']),n:{t:'int',v:1}});
        }

      }
  //
    }else if (aI === 'borderWidth'){
      capTitle = 'Width';
      min = 0;
      max = 10;

      var origBorderStyle = getOrig('borderStyle');
      var origBorderColor = getOrig('borderColor');

      if (origBorderColor === false){
        addChanges.push({t:'w',w:objPath.concat(['s', 'borderColor']),n:{t:'raw',v:'rgb(0,0,0)'}});
      }
      if (origBorderStyle === false){
        addChanges.push({t:'w',w:objPath.concat(['s', 'borderStyle']),n:{t:'raw',v:'solid'}});
      }

  //
    }else if (aI === 'fontSize'){
      step = 0.01;
      uintChoices = StyleFunctions.fontWidthPieces(anItem.lim);
      capTitle = 'Font Size';
      doCombo = true;
      min = 0.01;
      max = 100;
      if (!origDistance1){
        origDistance = 1;
      }
    }else if (isInfo(aI)){
      step = 0.01;
      uintChoices = [{t:'dc', n:'Decimal'}];
      if (anItem.i === 'sca'){
        capTitle = 'X/Y Ratio';
        min = 0;
        max = 10;
      }else if (anItem.i === 'cL' || anItem.i === 'cR' || anItem.i === 'cT' || anItem.i === 'cB'){
        min = 0;
        max = 10000;
        if (anItem.i === 'cL'){
          capTitle = 'Crop Left';
        }else if (anItem.i === 'cR'){
          capTitle = 'Crop Right';
        }else if (anItem.i === 'cT'){
          capTitle = 'Crop Top';
        }else if (anItem.i === 'cB'){
          capTitle = 'Crop Bottom';
        }
      }
    }else if (anItem.i === 'l' || anItem.i === 't' || anItem.i === 'w' || anItem.i === 'h' || anItem.i === 'r' || anItem.i === 'b' || anItem.i === 'maxWidth' || anItem.i === 'maxHeight' || anItem.i === 'minWidth' || anItem.i === 'minHeight' || anItem.i === 'logoWidth' || aI === 'lineHeight' || aI === 'width' || aI === 'height' || aI === 'rowHeight' || anItem.i === 'spacingGap'){
      step = 0.01; min = 0; max = 1000; uintChoices = StyleFunctions.decimalWidthPieces();
      if (anItem.i === 'l'){
        capTitle = 'Left';
      }else if (anItem.i === 't'){
        capTitle = 'Top';
      }else if (anItem.i === 'b'){
        capTitle = 'Bottom';
      }else if (anItem.i === 'r'){
        capTitle = 'Right';
      }else if (anItem.i === 'w' || aI === 'width'){
        min = 1;
        capTitle = 'Width';
      }else if (anItem.i === 'logoWidth' ){
        if (!origDistance){
          origDistance = 100;
        }
        min = 1;
        capTitle = 'Logo Width';
      }else if (anItem.i === 'spacingGap' ){
        if (!origDistance){
          origDistance = 10;
        }
        min = 0;
        capTitle = 'Gap between image and text';
      }else if (anItem.i === 'h' || aI === 'height'){
        min = 1;
        capTitle = 'Height'
      }else if (anItem.i === 'lineHeight'){
        min = 1;
        canRemove = 'Default';
        max = 10;
        capTitle = 'Line Height'
      }else if (anItem.i === 'rowHeight'){
        min = 1;
        canRemove = 'Default';
        capTitle = 'Row Height'
      }else if (anItem.i === 'maxWidth' || anItem.i === 'maxHeight' || anItem.i === 'minWidth' || anItem.i === 'minHeight'){
        min = 1;
        // uintChoices = [{t:'px', n:'Pixels'}];
        canRemove = 'Remove';
        if (anItem.i === 'maxWidth'){
          capTitle = 'Max Width';
        }else if (anItem.i === 'maxHeight'){
          capTitle = 'Max Height';
        }else if (anItem.i === 'minWidth'){
          capTitle = 'Min Width';
        }else if (anItem.i === 'minHeight'){
          capTitle = 'Min Height';
        }
      }
    }else{
      console.warn(anItem);
    }

  function submitValueAndUnit(set){
    submitGeneric(set, anItem.i, addChanges);
  }

    var removePiece = null;
    if (canRemove){
      if (!origDistance){
        if (canRemove === 'Remove'){
          removePiece = <span>Not Specified</span>
//
        }else{
          removePiece = <span>Current Value : Default</span>
        }
//        
      }else{
        function removeValue(){
          var changes = [{t:'r', w:stylePath, i:anItem.i}];
          organicChanges(changes);
        }
        removePiece = <button className='btn btn-primary' onClick={removeValue}>{canRemove}</button>

      }
    }
//

    var staticDynamic1;
    var needBreak1 = null;
    var currentAns2 = 0;
    if (anItem.f){
      function doStatic(e){
        submitGeneric({t:uintIn, v:min}, anItem.i, addChanges);
      }
      if (ResponsiveFns.isFormula(currentScreenStyle, anItem.f, anItem.i)){
        currentAns2 = 1;
      }
      needBreak1 = <br/>
      var b1 = [{t:'Static',i:0,f:doStatic, ic:'carbon:locked'}, {t:'Dynamic', ic:'carbon:unlocked', i:1,f:formulaPieceInGeneral(anItem.i, capTitle, anItem.f)}];
      staticDynamic1 = <TableGrid options={b1} currentAnswer={currentAns2} onClick={setMultipleX} />
    }
    var co1;
    if (currentAns2 === 0){
        co1 = <div>{needBreak1}<DistanceSelector title={capTitle} changeWhat={anItem.i} origDistance={origDistance} step={step} min={min} max={max} uintChoices={uintChoices} origUnit={uintIn} submitValueAndUnit={submitValueAndUnit} insetWidth={insetWidth} insetHeight={insetHeight} doCombo={doCombo} screenSize={screenSize}/>
          {removePiece}</div>
    //

//
    }else{
      co1 = formulaPiece(anItem, capTitle);
    }

//
    return (<td>
      {guidePiece}
    {capTitle}<br/>
    <center>
      {staticDynamic1}
      {co1}</center></td>)
//

}




//
export default App;
